export const SUBSCRIBERS_ONLY_CONTENT = '구독회원만 이용 가능합니다.';
export const NO_POSTING_PERMISSION = '게시글 작성 권한이 없습니다.';
export const SUBSCRIBERS_ONLY_ACCESS = '구독회원만 열람 가능합니다.';
export const FULL_SUBSCRIPTION_ONLY_ACCESS = '대가 전체 구독 회원만 열람 가능합니다.';
export const FULL_SUBSCRIPTION_AND_STUDENT_ONLY_ACCESS = '전체 구독 제자회원만\n 열람 가능합니다.';
export const FULL_SUBSCRIPTION_AND_STUDENT_ONLY_ACCESS_SUB = '7인 구독중인 제자회원만 열람 가능합니다.';
export const SUBSCRIBED_STUDENT_ACCESS_ONLY = '1인 이상 구독한 제자회원만\n열람 가능합니다.';
export const SUBSCRIBED_STUDENT_ACCESS_ONLY_SUB = '1인 이상 구독중인 제자회원만 열람 가능합니다.';
export const WEB_ONLY_SUBSCRIPTION_PAYMENT =
	'구독결제는 웹환경에서 가능합니다.\n네이버에 대가의 선택 검색 후 링크접속해\n신청해주시길 바랍니다.';
export const LOGIN_REQUIRED = '로그인이 필요합니다.';
export const LOGIN_REQUIRED_PAGE = '로그인이 필요한 페이지입니다.';
export const ALREADY_ALL_SUBSCRIPTION = '이미 전체 대가를 구독중입니다.';
export const SUBSCRIPTION_RETRY = '구독 상품 변경 시 구독 해지 후 다시 시도해 주세요.';
export const MESSAGE_MENU_UNDER_PREPARATION =
	'해당 메뉴는 현재 준비중입니다.\n자세한 내용은 오픈 전 공지사항을 통해\n 안내드리겠습니다.';
export const MESSAGE_PC_MENU_UNDER_PREPARATION =
	'해당 메뉴는 현재 준비중입니다.\n자세한 내용은 오픈 전 공지사항을 통해 안내드리겠습니다.';
export const CONFIRM = '확인';
export const CANCEL = '닫기';
export const DELETE = '삭제';
export const CONFIRM_DELETE_ITEM = '삭제 하시겠습니까?';
export const CONFIRM_EDIT_ITEM = '수정 하시겠습니까?';
export const MESSAGE_DELETE_COMPLETED = '삭제가 완료되었습니다.';
export const CONFIRM_PAYMENT = '구독하러 가기';
export const CONFIRM_LOGIN = '로그인하러 가기';
export const CONFIRM_SIGNUP = '회원가입하러 가기';
export const ALREADY_LOGGED_IN = '이미 로그인 하셨습니다.';
export const ALREADY_ID = '이미 사용중인 아이디입니다.';
export const ALREADY_NICKNAME = '이미 사용중인 닉네임입니다.';
export const FEATURE_UNDER_DEVELOPMENT = '해당 기능은 현재 개발중입니다.';
export const COMING_SOON = '빠른 시일 내에 사용하실 수 있도록 하겠습니다';
export const CHANGE_PW = '비밀번호가 변경되었습니다.';
export const ERROR_PASSWORD_SAME_AS_CURRENT = '사용중인 비밀번호와 동일합니다.\n다른 비밀번호로 다시 입력해주세요.';
export const COMPANY_TITLE = '대가의 선택';
export const ERROR_PASSWORD_REQUIREMENTS = '영문,숫자 조합 6자리 이상입니다.';
export const ERROR_PASSWORDS_DO_NOT_MATCH = '비밀번호가 일치하지 않습니다.';
export const ERROR_INVALID_PHONE_NUMBER = '휴대폰번호를 다시 확인해 주세요';
export const ERROR_PHONE_VERIFICATION_REQUIRED = '휴대폰번호 인증을 완료해주세요';
export const ERROR_ID_PASSWORD_MISMATCH = '아이디 또는 비밀번호가 일치하지 않습니다.';
export const ERROR_OCCURRED = '오류가 발생했습니다.';
export const ERROR_SIGNUP_FAILED = '회원가입 실패';
export const MESSAGE_TRY_AGAIN_LATER = '잠시 후 다시 시도해주세요';
export const MESSAGE_POST_COMPLETED = '작성이 완료되었습니다.';
export const SAVE_POST_COMPLETED = '저장이 완료되었습니다.';
export const CONFIRM_REGISTER_POST = '작성하신 글을 등록하시겠습니까?';
export const MESSAGE_REGISTRATION_COMPLETED = '등록이 완료되었습니다.';
export const MESSAGE_EDIT_COMPLETED = '수정 완료되었습니다.';
export const CONFIRM_DELETE_POST = '삭제 하시겠습니까?';
export const MESSAGE_POST_DELETED = '게시글이 삭제되었습니다.';
export const MESSAGE_RESEND_AVAILABLE_AFTER_20_SECONDS = '20초 이후 재전송 가능합니다.';
export const MESSAGE_POST_CODE = '인증번호가 전송되었습니다.';
export const MESSAGE_POST_RE_CODE = '인증번호가 재전송되었습니다.';
export const ERROR_EXCEEDED_VERIFICATION_LIMIT = '인증 요청 제한 횟수를 초과했습니다.\n24시간 후에 다시 시도해 주세요.';
export const ERROR_SEND_VERIFICATION_FAILED = '인증번호 전송에 실패하였습니다. \n잠시 후 다시 시도해 주세요.';
export const MESSAGE_VERIFICATION_COMPLETED = '인증이 완료되었습니다.';
export const ERROR_DUPLICATE_PHONE_NUMBER = '기존과 동일한 휴대폰번호입니다.';
export const ERROR_VERIFICATION_CODE_MISMATCH = '인증번호가 일치하지 않습니다. 다시 시도해 주세요.';
export const UNFAVORITE_PROMPT = '관심종목에서 해제하시겠습니까?';
export const MESSAGE_CANCEL_COMPLETED = '해제가 완료되었습니다.';
export const ACCOUNT_NOT_FOUND = '해당 번호로 가입된 계정이 없습니다.';
export const PHONE_NUMBER_MISMATCH = '해당 아이디로 등록된 휴대폰번호와 일치하지 않습니다.';
export const CANCEL_SUBSCRIPTION_REASON = '해지 사유를 선택해주세요.';
export const CANCEL_SUBSCRIPTION_REASON_GUIDE = '(중복 선택 가능)';
export const UNSUBSCRIPTION_SUCCESS = '구독해지가 완료되었습니다.';
export const THANK_YOU_MESSAGE = '소중한 의견 감사합니다.';
export const ONLY_PICKED = '종목 점수는 구독중인 대가의 이달의 포착주로 선정된 종목만 조회가 가능합니다.';
export const NO_PERMISSION = '접근 권한이 없습니다.';

// validation
export const ERROR_INVALID_FORMAT = '한글, 영문 형식으로 입력해주세요.';
export const ERROR_REQUIRED_FIELD = '필수 입력 항목입니다.';
export const MESSAGE_ID_DUPLICATE_CHECK_COMPLETED = '아이디 중복확인을 완료해주세요.';
export const ERROR_INVALID_ID_FORMAT = '6~12자의 영문,숫자만 사용 가능합니다.';
export const ERROR_INVALID_INPUT_FORMAT = '2~8자의 한글,영문,숫자만 사용 가능합니다.';
export const MESSAGE_NICKNAME_DUPLICATE_CHECK_COMPLETED = '닉네임 중복확인을 완료해주세요.';
export const MESSAGE_PASSWORD_REQUIREMENTS = '영문, 숫자를 조합하여 6자리 이상 입력해주세요.';
export const MESSAGE_VERIFY_PHONE_NUMBER = '휴대폰번호를 다시 확인해 주세요';
export const MESSAGE_PHONE_VERIFICATION_COMPLETED = '휴대폰번호 인증을 완료해주세요';
export const MESSAGE_REFERRER_DUPLICATE_CHECK_COMPLETED = '추천인 중복 확인을 완료해주세요';
export const ERROR_ALREADY_RECOMMEND = '유효하지 않은 추천인 코드입니다.';
export const MESSAGE_NICKNAME_VERIFICATION_COMPLETED = '닉네임 인증을 완료해주세요';
export const ERROR_INVALID_PROMO_CODE = '올바르지 않은 프로모션 코드입니다.';
export const ERROR_USED_PROMO_CODE = '이미 사용한 프로모션 코드입니다.';
export const UNREGISTERED_ID = '등록되지 않은 아이디입니다.';
export const REGISTRATION_SUCCESS = '회원가입이 완료되었습니다.';
export const REGISTRATION_CONGRATULATIONS = '회원가입을 축하합니다!';
export const CANT_AIR = '현재 방송 시청이 불가합니다.';

//placeholder
export const ERROR_PASSWORD_REQUIRED = '비밀번호를 입력해주세요';
export const INPUT_CONTENTS = '내용을 입력해주세요.';
export const PLACEHOLDER_TITLE = '제목을 입력해 주세요.';
export const PLACEHOLDER_TITLE_30 = '30자 이내 입력';
export const PLACEHOLDER_TITLE_50 = '50자 이내 입력';
export const PLACEHOLDER_CODE = '코드번호를 입력해주세요.';
export const PLACEHOLDER_ENTER_NEW_PASSWORD_AGAIN = '새 비밀번호를 한번 더 입력해 주세요.';
export const PLACEHOLDER_SEARCH_TITLE_OR_AUTHOR = '제목 또는 작성자 닉네임을 검색해 주세요.';
export const PLACEHOLDER_SEARCH_TITLE = '[기업분석] 종목명 또는 티커 입력';
export const LABEL_SEARCH_BY_NAME_OR_CODE = '종목명 또는 종목 코드 검색';
export const INPUT_ID = '아이디 입력';
export const INPUT_NAME = '실명 입력';
export const INPUT_PW = '비밀번호 입력';
export const INPUT_CODE = '인증번호 입력';
export const INPUT_COMMENT =
	'8월 14일 금감원의 자본시장법 강화로 인해 양방향 소통이 제한되어 댓글 기능을 중단했습니다. 더 나은 방향으로 개선할 수 있도록 준비하겠습니다. 감사합니다.';
export const ERROR_INVALID_ID = '6~12자의 영문, 숫자';
export const ERROR_INVALID_INPUT = '2~8자의 한글, 영문, 숫자';
export const PLACEHOLDER_PASSWORD_RE = '비밀번호 재입력';
export const LABEL_SEARCH_STOCK = '종목명 또는 종목 코드 검색';
export const PLACEHOLDER_PASSWORD_REQUIREMENTS = '영문, 숫자 조합 6자리 이상';
export const PLACEHOLDER_NUMBERS_ONLY_EXCEPT_DASH = "'-' 제외 숫자만 입력";
export const PLACEHOLDER_PASSWORD_RULE = '6~20자의 영문, 숫자';

// tooltip
export const WEEKLY_INCREASE_TOOLTIP = '대가의 현재 종목 중 한주간의 상승률이 높은 종목이 선정됩니다.';
export const HOT_RANK_TOOLTIP =
	'최근 성장이 돋보이는 섹터, 저평가, 고배당 등 특정 키워드에 부합한 종목들을 쉽게 확인할 수 있습니다.';
export const BEST_INCREASE_TOOLTIP = '해당 기간 기준 대가종목 중 상승률이 가장 놓은 종목이 선정됩니다.';
export const TOP_GAINING_SECTOR_THEME_TOOLTIP =
	'11개 업종, 20개 테마의 상승률과 정보, 주요종목 등을 확인할 수 있습니다.';
export const BIG_HOLDERS_PORTFOLIO_TOOLTIP =
	'"거인의 어깨에 올라타라" 투자 거장들의 실제 보유 포트를 확인할 수 있습니다.';
export const ETF_TOOLTIP =
	'지수 추종, 주도 섹터, 채권 등 다양한 ETF를 통해 효율적인 자산 배분과 글로벌 투자 정보를 확인할 수 있습니다.';
export const COMPANY_ANALYSIS_TOOLTIP = '※해당 데이터는 최신 분기 기준 데이터입니다.';

// guide
export const FINANCE_STATEMENT_KR = '*이익률 외 재무데이터는 백만원 단위로 표시';
export const FINANCE_STATEMENT_KR_MIL = '*이익률 외 재무데이터는 억원 단위로 표시';
export const FINANCE_STATEMENT_USA = '*이익률 외 재무데이터는 백만달러 단위로 표시';
export const FINANCE_STATEMENT_JPN = '*이익률 외 재무데이터는 백만엔 단위로 표시';
export const FINANCE_RATIO = '*총주식수(천주)는 최신 업데이트일 기준으로 작성된 데이터입니다.';
export const FINANCE_RATIO_KR = '*총주식수는 최신 업데이트일 기준으로 작성된 데이터입니다.';
export const FINANCE_INDICATOR = '*재무데이터는 원(KRW)으로 일괄조정';

// field success
export const MESSAGE_ID_VERIFICATION_COMPLETED = '아이디 인증이 완료되었습니다.';
export const MESSAGE_AVAILABLE_ID = '사용 가능한 아이디입니다.';
export const MESSAGE_AVAILABLE_NICKNAME = '사용 가능한 닉네임입니다.';

// native
export const ERROR_MEMBER_REGISTRATION_REQUIRED = '회원 정보 등록이 필요합니다.';
export const MESSAGE_DOWNLOAD_COMPLETED = '다운로드 완료되었습니다.';
export const MESSAGE_DOWNLOAD_FAILED = '다운로드 실패하였습니다.';
export const MESSAGE_REQUIRED_UPDATE = '필수 업데이트가 있습니다! \n업데이트를 진행해주세요.';

// audio
export const MESSAGE_AUDIO_FILE_NOT_FOUND = '해당 기업은 현재 업데이트 준비중 입니다.';

// menu
export const ALL = 'ALL';
export const SMALL_CAP_STOCK = '소형주';
export const MID_SMALL_CAP_STOCK = '중소형주';
export const MID_LARGE_CAP_STOCK = '중대형주';
export const MARKET_CAP_CRITERIA = '시가총액 기준';
export const ONE_MONTH = '1개월';
export const THREE_MONTH = '3개월';
export const SIX_MONTH = '6개월';
export const MORE = '더보기';
export const HOT_RANK = 'Hot 랭킹';
export const STOCK_MENU_TAB = [
	{ tab: SMALL_CAP_STOCK, unit: '<strong>3,000</strong>억원 이하' },
	{ tab: MID_SMALL_CAP_STOCK, unit: '<strong>3,000</strong>억원~<strong>1</strong>조원' },
	{ tab: MID_LARGE_CAP_STOCK, unit: '<strong>1</strong>조원 초과' },
];
export type tabType = {
	tab: string;
	current: string;
};
export const STOCK_MENU_TAB_LIST: tabType[] = [
	{ tab: ALL, current: '' },
	{ tab: SMALL_CAP_STOCK, current: 'SMA' },
	{ tab: MID_SMALL_CAP_STOCK, current: 'STM' },
	{ tab: MID_LARGE_CAP_STOCK, current: 'MTL' },
];
export const STOCK_MENU_TAB_NOT_ALL_LIST: tabType[] = [
	{ tab: SMALL_CAP_STOCK, current: 'SMA' },
	{ tab: MID_SMALL_CAP_STOCK, current: 'STM' },
	{ tab: MID_LARGE_CAP_STOCK, current: 'MTL' },
];
export const MONTH_MENU_TAB = [ONE_MONTH, THREE_MONTH, SIX_MONTH];
